module.exports = "https://static.wanderu.com/static/media/thenewyorker.d0937c86.png";